import React, { Component } from 'react';
import _ from 'lodash';
import { Accordion, Button, Icon } from 'semantic-ui-react';
import { format } from 'date-fns';
import DateFNSPT from 'date-fns/locale/pt';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// local
// css
import './ConfirmDelivery.scss';
// view
import ConfirmSendModal from './ConfirmSendModal';
import Page from 'app/ui/pages/Page';
import ConfirmTable from './ConfirmTable';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// actions
import { listConfirmDelivery, confirmPendingDelivery, resetPendingDelivery, openEdit } from 'app/redux/actions/confirmDelivery/data';
import { openModal } from 'app/redux/actions/confirmDelivery/confirmModal';

class ConfirmDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: [],
        };
    }

    componentDidMount() {
        this.props.dispatch(listConfirmDelivery());
    }

    componentWillUnmount() {
        this.props.dispatch(resetPendingDelivery());
    }

    onClickRequest = () => {
        // filter only for the saved ones
        let replacements = this.props.confirmDelivery.data
            .map(r => r.entries)
            .reduce((a, b) => a.concat(b))
            .filter(r => r.isSaved === true);
        // send to the server
        this.props.dispatch(openModal(replacements));
    };

    onClickConfirm = replacements => this.props.dispatch(confirmPendingDelivery(replacements));

    handleClickAccordionTitle = (e, prop) => {
        const { hidden } = this.state;
        const { index } = prop;
        const pos = hidden.indexOf(index);
        if (pos === -1) {
            hidden.push(index);
        } else {
            hidden.splice(pos, 1);
        }
        this.setState({ hidden });
    };

    isHidden = index => this.state.hidden.indexOf(index) === -1;

    clickEditConfirm = () => this.props.dispatch(openEdit());

    renderEmpty = () => <EmptyList emptyMessage="Nenhuma reposição programada." />;

    renderData(data) {
        return (
            <Accordion fluid>
                {_.map(data, row => {
                    const key = `accordion-${row.id}`;
                    const dateFormatter = row.isFromYesterday === true ? '[Ontem] (dddd - DD/MM/YYYY)' : 'dddd - DD/MM/YYYY';
                    return (
                        <React.Fragment key={key}>
                            <Accordion.Title active={this.isHidden(row.id)} index={row.id} onClick={this.handleClickAccordionTitle}>
                                <Icon name="dropdown" /> {format(row.date, dateFormatter, { locale: DateFNSPT })}
                            </Accordion.Title>
                            <Accordion.Content active={this.isHidden(row.id)}>
                                <ConfirmTable row={row} />
                            </Accordion.Content>
                        </React.Fragment>
                    );
                })}
            </Accordion>
        );
    }

    render() {
        const { data, loading } = this.props.confirmDelivery;
        const isEmpty = _.isEmpty(data);
        return (
            <Page id="page-confirm" loading={loading}>
                <div className="page-header">
                    <div className="page-title">Confirme as reposições programadas para:</div>
                    <div>
                        <span id="edit-confirm-link" onClick={this.clickEditConfirm}>
                            Editar confirmações
                        </span>
                        <Button content="CONFIRMAR ENTREGAS" onClick={this.onClickRequest} disabled={isEmpty} />
                    </div>
                </div>
                <div className="body">{isEmpty ? this.renderEmpty() : this.renderData(data)}</div>
                <ConfirmSendModal onClickConfirm={this.onClickConfirm} />
            </Page>
        );
    }
}

ConfirmDelivery.propTypes = {
    dispatch: PropTypes.func,
    confirmDelivery: PropTypes.object,
};

const mapStateToProps = state => ({
    confirmDelivery: state.confirmDelivery,
});
export default connect(mapStateToProps)(ConfirmDelivery);
